import { createUseStyles } from 'react-jss'

export const style = {
  pointer: {
    cursor: 'pointer'
  },
  sideBySideChart: {
    marginLeft: -12,
    '&:last-child': {
      marginLeft: 12
    }
  },
  sideBySideChartFilterBar: {
    display: 'flex',
    width: '100%',
    marginTop: 12,
    marginBottom: 8,
    position: 'relative',
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '50%'
    },
    '& .split-chart-filter-bar-element:first-child': {
      paddingLeft: 32
    },
    '& .split-chart-filter-bar-element:last-child': {
      paddingLeft: 44
    }
  }
}

export const useStyles = createUseStyles(style)
